import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

type LanguageSwitchProps = {
  className?: string;
};

const LanguageSwitch: React.FC<LanguageSwitchProps> = ({ className }) => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className={`flex items-center gap-2 rounded-full bg-white/80 p-1 shadow ${className ?? ''}`}>
      <button
        type="button"
        onClick={() => setLanguage('id')}
        className={`rounded-full px-3 py-1 text-xs font-semibold transition ${
          language === 'id' ? 'bg-accent text-white shadow-md' : 'text-gray-600 hover:text-dark-blue'
        }`}
      >
        ID
      </button>
      <button
        type="button"
        onClick={() => setLanguage('en')}
        className={`rounded-full px-3 py-1 text-xs font-semibold transition ${
          language === 'en' ? 'bg-accent text-white shadow-md' : 'text-gray-600 hover:text-dark-blue'
        }`}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitch;
